import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        flexDirection: 'column'
    },
    headingContainer: {
        justifyContent: 'center',
        width: '100%'
    },
    heading: {
        fontSize: 19,
        fontFamily: Theme.boldFont,
        color: Theme.labelTextColor,
        marginBottom: 18
    },
    itemsContainer: {
        flexDirection: 'column'
    },
    itemContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 180,
        paddingBottom: 10
    },
    itemLabelContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    itemLabel: {
        fontSize: 20,
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor
    },
    radioButton: {
        width: 30,
        height: 30,
        borderWidth: 1,
        borderRadius: 100,
        borderColor: Theme.secondaryButtonBorderColor,
        backgroundColor: Theme.alertTextColor,
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 15
    },
    radioButtonSelectedPoint: {
        width: 12,
        height: 12,
        borderRadius: 100,
        backgroundColor: Theme.primaryActiveColor
    }
};

export default StyleSheet.create(baseStyles);
